import { Reducer } from 'redux';
import { StudentActionTypes } from '../types';

const initialState: any = [];

const reducer: Reducer<any> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return action.payload.student.emails ?? [];
    default:
      return state;
  }
};

export { reducer as emailsReducer };
